/* eslint-disable no-use-before-define */

import React from 'react'
import Grid from './grid'
import {default as useQuickIdeas, onViewAll} from './use-quick-ideas'
import { Disclosures, Loading, getState } from '../../twd'


export default () => {

    const Last = getState('overview.quick-ideas')
    const [invType, setInvType_] = React.useState(Last.value.invType || 'S')
    const setInvType = React.useCallback((s) => {
        Last.set({invType:s})
        setInvType_(s)
    }, [])

    const { status: status_s, data: data_s} = useQuickIdeas({
        id: 'QUICK_IDEAS_SAFEST_CDS',
        url: '/esb/retailservice/quickIdeasService/getSafest',
        params: {state:null, quickPickGroupSubTypeList: ['QUICK_IDEAS_SAFEST_CDS']}
    })

    const { status: status_t, data : data_t} = useQuickIdeas({
        id: 'QUICK_IDEAS_SAFEST_TREAS',
        url: '/esb/retailservice/quickIdeasService/getSafest',
        params: {state:null, quickPickGroupSubTypeList: ['QUICK_IDEAS_SAFEST_TREAS']}
    })

    const isCD = invType==='S'

    return <React.Fragment>
        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-md-12 col-xs-12">
            <h3 style={{display:'inline-block', paddingRight:'10px'}} className="medium-header">Conservative</h3>
            <Disclosures
                dataModule='overview-quick-ideas'
                dataCategory='conservative'
                dataName='overview-quick-ideas-conservative-learn-more-link'
                label='Learn more'
                html={DISCLOSURES} />
        </div></div>

        <div className="row vertical-offset-sm"><div className="col-md-12 col-xs-12">
        Short and medium-term Treasuries and new issue CDs which provide strong principal preservation.
        </div></div>

        <div className="row vertical-offset-sm">
            <div
                data-name='overview-quick-ideas-conservative-nav-tabs'
                className="col-md-6 col-xs-12 nav-tabs">
            <ul>
                <li className={ isCD ? 'active': '' }><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-cds-nav-tab'
                    onClick={() => setInvType('S')}>CDs</button></li>
                <li className={ !isCD ? 'active': '' }><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-treasuries-nav-tab'
                    onClick={() => setInvType('T')}>Treasuries</button></li>
            </ul>
            </div>

            {isCD && <div className="col-md-6 col-xs-12 equally-spaced">
                <div>Additional Offerings:</div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-cds-3-months-link'
                    className="link-button"
                    onClick={() => onViewCD({holdMaturityMin:'3m', holdMaturityMax:'4m'})}
                >3 months</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-cds-6-months-link'
                    className="link-button"
                    onClick={() => onViewCD({holdMaturityMin:'6m', holdMaturityMax:'7m'})}
                >6 months</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-cds-1-year-link'
                    className="link-button"
                    onClick={() => onViewCD({holdMaturityMin:'11m', holdMaturityMax:'13m'})}
                >1 year</button></div>
            </div>}

            {!isCD && <div className="col-md-6 col-xs-12 equally-spaced">
                <div>Additional Offerings:</div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-treasuris-less-than-1-year-link'
                    className="link-button"
                    onClick={() => onViewTreasury({holdTreasuryType:['Bills'], holdMaturityMax:'1y'})}
                >&lt;1 year</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-treasuris-between-1-year-to-5-year-link'
                    className="link-button"
                    onClick={() => onViewTreasury({holdTreasuryType:['Notes'], holdMaturityMin:'1y', holdMaturityMax:'5y'})}
                >1 - 5 years</button></div>
                <div><button
                    data-module='overview-quick-ideas'
                    data-category='conservative'
                    data-name='overview-quick-ideas-conservative-treasuris-between-5-year-to-10-year-link'
                    className="link-button"
                    onClick={() => onViewTreasury({holdTreasuryType:['Notes', 'Bonds'], holdMaturityMin:'5y', holdMaturityMax:'10y'})}
                >&gt;5 - 10 years</button></div>
            </div>}

        </div>

        <div className="row"><div className="col-md-12">
        <Loading status={isCD ? status_s : status_t}>
            <Grid
                dataCategory='conservative'
                dataName='overview-quick-ideas-convservative'
                rows={isCD ? data_s : data_t}
                showFrequency={true} />
        </Loading>
        </div></div>

    </React.Fragment>
}

const onViewCD = (p) => {
    let searchParams = Object.assign({
        holdInvType: ['S'],
        offeringType: ['primary','ask-side'],
        quantityMin: 10,
        holdCouponTypeCode: ['FNZR'],
        holdCallableInd: ['N'],
        persistToPreviousSearches: false,
        sort: [{ field:'askYield', direction:'DESC' }]
    }, p)
    onViewAll({searchParams})
}

const onViewTreasury = (p) => {
    let searchParams = Object.assign({
        holdInvType: ['T'],
        offeringType: ['ask-side'],
        holdTreasuryType: ['Bills', 'Notes'],
        holdMaturityMax: '10y',
        quantityMin: 10,
        clientPriceMin: 95,
        clientPriceMax: 120,
        persistToPreviousSearches: false,
        sort: [{ field:'askYield', direction:'DESC' }]
    }, p)
    onViewAll({searchParams})
}

const DISCLOSURES = `
    <p>
    This category features more conservative CD and Treasury bond search results.
    By default, the module will default to CD results.
    Click the “Treasuries” tab to load Treasury results.
    The results displayed will adhere to the following criteria:
    </p>

    <p>
    <b>CD Result Criteria:</b>  New issue CDs with maturities ranging from three months to one year.
    All results displayed are from dealers offering a minimum of 10 bonds.
    The result displayed in each row represents the highest yielding offering within its designated maturity range.
    Each of the three rows will feature a unique maturity range.  Row 1: (3m - 4m), Row 2: (6m - 7m), Row 3: (11m-13m).
    </p>

    <p>
    <b>Treasury Result Criteria:</b>  Short-term Treasury bills with maturities of less than one year
    to medium-term Treasury notes with maturities upwards of 10 years.
    All results displayed are from dealers offering a minimum of 10 bonds, with an offering price between 95 and 120.
    The result displayed in each row represents the highest yielding offering within its designated maturity range.
    Each of the three rows feature a unique maturity range.  Row 1: (<1yr), Row 2: (>1yr – 5yr), Row 3: (>5yr - 10yr).
    </p>`


// WEBPACK FOOTER //
// ./src/overview/quick-ideas/conservative.js